export const PATH_BUSINESS_UNITS = "/business-units";
export const PATH_BUSINESS_UNITS_ID = `${PATH_BUSINESS_UNITS}/:id`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS = `${PATH_BUSINESS_UNITS_ID}/settings`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_DESCRIPTION = `${PATH_BUSINESS_UNITS_ID_SETTINGS}/description`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_FIRMWARES = `${PATH_BUSINESS_UNITS_ID_SETTINGS}/firmwares`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_FIRMWARES_UUID = `${PATH_BUSINESS_UNITS_ID_SETTINGS_FIRMWARES}/:uuid`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_LOGS = `${PATH_BUSINESS_UNITS_ID_SETTINGS}/logs`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_USERS = `${PATH_BUSINESS_UNITS_ID_SETTINGS}/users`;
export const PATH_BUSINESS_UNITS_ID_SETTINGS_USERS_LOGIN = `${PATH_BUSINESS_UNITS_ID_SETTINGS_USERS}/:userLogin`;
